import MuxPlayer from "@mux/mux-player-react"; 

import paymentMethods from './images/paymentmethods.png';
import './App.css';
import { useForm } from "react-hook-form";


function App() {
  const { register, setValue, watch, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      donationValue: 10,
    }  
  });
  
  
  const url = `https://www.paypal.com/cgi-bin/webscr?cmd=_donations&business=karmagawa.donations@gmail.com&item_name=Donation&item_number=Karmagawa+Campaign&amount=${watch("donationValue")}&currency_code=USD`
  console.log(url)
  
  const onSubmit = data =>  {
    const url = `https://www.paypal.com/cgi-bin/webscr?cmd=_donations&business=karmagawa.donations@gmail.com&item_name=Donation&item_number=Karmagawa+Campaign&amount=${data.donationValue}&currency_code=USD`
    window.toplocation.replace(`${url}`)
  };
  // const watchDonationValue = watch("donationValue");

  return (
    <div className="App">
      <header className="App-header">
        <div className="video">
          <MuxPlayer
            streamType="on-demand"
            playbackId="8thOj01901VrUz02hguIj8FcbX602S34uodzxUGK8ZofBq8"
            autoPlay="any"
            loop
          />
          <h1>JOIN US IN HELPING COMMUNITIES WORLDWIDE!</h1>
        </div>
        <div className="donationForm">
        <form onSubmit={handleSubmit(onSubmit)}>
          <h6>How much would you like to donate?</h6>
          <div className="radio-group">
            <label><input onClick={() => setValue("donationValue", "10")} {...register("radioValue")} type="radio" value="10" defaultChecked/><span>$10</span></label>
            <label><input onClick={() => setValue("donationValue", "25")} {...register("radioValue")} type="radio" value="25" /><span>$25</span></label>
            <label><input onClick={() => setValue("donationValue", "50")} {...register("radioValue")} type="radio" value="50" /><span>$50</span></label>
            <label><input onClick={() => setValue("donationValue", "100")} {...register("radioValue")} type="radio" value="100" /><span>$100</span></label>
          </div>
            <input className="input-field" {...register("donationValue", "10")} defaultValue="10" />
            
            <a target="_blank" href={url} className="submit-btn">Donate</a>
            <br />
            <img src={paymentMethods} />
        </form>
        </div>
        <div className="info-banner">
          <p>Please help these amazing kids get an education by building them a SCHOOL. Sadly, they are currently living in poverty with no hope for a change.</p>
        </div>


        <div className="whatyourmoneypaysfor">
          <ul>
          <li><span className="title">$10</span> <span>pays for a week of school supplies</span></li>
          <li><span className="title">$25</span> <span>pays for a month of school supplies</span></li>
          <li><span className="title">$50</span> <span>pays for a semester of tuition</span></li>
          <li><span className="title">$100</span> <span>pays for half a year of tuition</span></li>
          </ul>
        </div>

        <div className="screening-banner">
          <p>
            Other ways to donate:<br/>
            <a href="https://www.facebook.com/karmagawafans/fundraisers" target="_blank"><span className="title">Facebook</span> </a><br/>
            <a href="https://www.paypal.com/paypalme/karmagawadonations" target="_blank"><span className="title">Paypal</span></a> <br/>
            <a href="https://karmagawa.com/collections/all" target="_blank"><span className="title">Merch</span></a> <br/>
          </p>
        </div>
      </header>
    </div>
  );
}

export default App;
